module.exports = __webpack_public_path__ + "static/media/Siemens_Sans_Bold.f1206273.ttf";